var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-list-header"},[_c('HeaderAvatar',{attrs:{"hasBorder":false,"image":'https://static.max-c.com/static/heybox/webapp/game/palworld/database/game-logo.png'}}),_c('div',{staticClass:"info"},[_c('div',{staticClass:"row-1"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"row-2"},[_vm._v(_vm._s(_vm.desc))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }